export default {
  bind(el, binding) {
    if (binding.value) {
      el.addEventListener('mouseenter', () => {
        // 创建提示元素
        const tooltip = document.createElement('div');
        tooltip.className = 'custom-tooltip';
        tooltip.style.position = 'absolute';
        tooltip.style.background = 'rgba(0, 0, 0, 0.7)';
        tooltip.style.color = '#fff';
        tooltip.style.padding = '4px 8px';
        tooltip.style.borderRadius = '4px';
        tooltip.style.fontSize = '12px';
        tooltip.style.zIndex = '9999';
        tooltip.style.pointerEvents = 'none';
        tooltip.style.whiteSpace = 'nowrap';
        tooltip.innerText = binding.arg || '提示信息';
        
        // 计算位置
        const rect = el.getBoundingClientRect();
        tooltip.style.left = `${rect.left + window.scrollX}px`;
        tooltip.style.top = `${rect.top + window.scrollY - 30}px`;
        
        // 添加到文档
        document.body.appendChild(tooltip);
        el._tooltip = tooltip;
      });
      
      el.addEventListener('mouseleave', () => {
        if (el._tooltip) {
          document.body.removeChild(el._tooltip);
          el._tooltip = null;
        }
      });
    }
  },
  unbind(el) {
    if (el._tooltip) {
      document.body.removeChild(el._tooltip);
      el._tooltip = null;
    }
  }
}